import React, { FunctionComponent, useState } from "react";

import { NoDataTile, Separator, Stack, useFieldArray } from "@bps/fluent-ui";

import { SubscriptionDetails } from "../subscription-details/SubscriptionDetails";
import { SubscriptionItems } from "./SubscriptionItems";
import { SubscriptionItemProducts } from "./SubscriptionItems.types";
import { SubscriptionFormHeader } from "./SubscriptionFormHeader";
import {
  CustomerProductsSubscription,
  Tenant
} from "@libs/api/gateways/plt/plt-gateway.dtos";
import { useRestCouponDialog } from "./subscription-form.hooks";

interface SubscriptionEditFormFieldsProps {
  tenant: Tenant;
  subscription: CustomerProductsSubscription | undefined;
  onRestCouponDialog: () => void;
}
export const SubscriptionEditFormFields: FunctionComponent<SubscriptionEditFormFieldsProps> = ({
  tenant,
  subscription,
  onRestCouponDialog
}) => {
  // state to show/hide add new subscription item dialog
  const [hidden, setHidden] = useState<boolean>(true);

  const { value: subscriptionProducts } = useFieldArray<
    SubscriptionItemProducts
  >("subscriptionProducts");

  useRestCouponDialog(onRestCouponDialog);

  return (
    <Stack
      grow
      tokens={{ childrenGap: 24 }}
      styles={{ root: { height: "100%" } }}
    >
      <SubscriptionFormHeader
        subscription={subscription}
        tenant={tenant}
        hidden={hidden}
        setHidden={setHidden}
      />
      <Stack grow>
        {subscriptionProducts.length ? (
          <>
            <SubscriptionDetails
              subscription={subscription}
              tenantId={tenant.id}
              customerTenantId={tenant.customerTenantId}
            />
            <Separator />
            <SubscriptionItems
              subscription={subscription}
              subscriptionProducts={subscriptionProducts}
              tenant={tenant}
            />
          </>
        ) : (
          <NoDataTile
            showBoxShadow={false}
            textProps={{ text: "There are no subscription items" }}
            linkProps={{
              text: "Add new subscription item",
              onClick: () => setHidden(false)
            }}
          />
        )}
      </Stack>
    </Stack>
  );
};
